'use strict';

/**
 * itOnScroll directive
 * Evaluates expression when scroll reaches the bottom of document.
 *
 * Usage:
 * <element it-on-scroll="expression"></element>
 *
 * Optional attributes:
 * threshold="[value in pixels]" - minimum distance from the bottom. By default threshold equals 0.
 * invert - evaluate expression when scroll reaches the top of document.
 * disable="true" - disables evaluation of expression
 */
const saOnScroll = [
  '$parse',
  '$timeout',
  '$window',
  '$rootScope',
  'throttle',
  'scrollTop',

  function ($parse, $timeout, $window, $rootScope, throttle, scrollTop) {
    var SCROLL_THROTTLE = 100;

    return {
      restrict: 'A',
      link: function postLink($scope, $element, $attr) {
        var window = angular.element($window);
        var bodyEl = $window.document.body;
        var scrollAction = $parse($attr.saOnScroll);
        var threshold = Number($attr.threshold) || 0;
        var inverted = angular.isDefined($attr.invert);
        var scrollHandlerThrottled;

        function executeAction() {
          scrollAction($scope);
        }

        function scrollHandler() {
          if (!$scope.$eval($attr.disable) && hasReachedThreshold(inverted)) {
            if (!$scope.$$phase) {
              $scope.$apply(executeAction);
            } else {
              executeAction();
            }
          }
        }

        function hasReachedThreshold(inverted) {
          var element = $element[0];
          var elementOffsetY = element.getBoundingClientRect().top - bodyEl.getBoundingClientRect().top;
          var elementHeight = $element[0].offsetHeight + elementOffsetY;
          var scrollOffset = scrollTop();
          var hasReached = false;

          if (!elementHeight) {
            hasReached = false;
          } else if (inverted) {
            hasReached = (scrollOffset <= threshold);
          } else {
            hasReached = (scrollOffset + bodyEl.offsetHeight >= elementHeight - threshold);
          }

          return hasReached;
        }

        // throttle calls to scroll handler
        scrollHandlerThrottled = throttle(scrollHandler, SCROLL_THROTTLE);

        // since the local listing is just hidden when we enter a local profile
        // the scroll handler is still available and $destroy is not called
        // we have to turn it off temporarily when viewing a local
        var unbindStateChange = $rootScope.$on('$stateChangeStart', (_, toState, toParams, fromState) => {
          var toViewLocal = (fromState.name === 'guides.list'
            || fromState.name === 'guides.city'
            || fromState.name === 'guides.cityFilter'
            || fromState.name === 'guides.listNoName'
            || fromState.name === 'guides.landing')
          && toState.name === 'guides.guide';
          var toViewLocals = (toState.name === 'guides.list'
            || toState.name === 'guides.city'
            || toState.name === 'guides.cityFilter'
            || toState.name === 'guides.listNoName'
            || toState.name === 'guides.landing')
          && fromState.name === 'guides.guide';
          if (toViewLocal) {
            window.off('scroll', scrollHandlerThrottled);
          }

          if (toViewLocals) {
            window.on('scroll', scrollHandlerThrottled);
          }
        });

        window.on('scroll', scrollHandlerThrottled);

        $scope.$on('$destroy', function () {
          window.off('scroll', scrollHandlerThrottled);
          unbindStateChange();
        });

        $timeout(scrollHandler);
      }
    };
  }
];

export default saOnScroll;



// WEBPACK FOOTER //
// ./app/src/directives/on_scroll.js